import { render, staticRenderFns } from "./DistrictManagerDashboard.vue?vue&type=template&id=ad10d254"
import script from "./DistrictManagerDashboard.vue?vue&type=script&lang=js"
export * from "./DistrictManagerDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports